import React, { FC } from 'react';
import { Skeleton } from 'antd';

export const FormSkeleton: FC<{ fields?: number }> = ({ fields = 5 }) => (
  <div data-testid="form-skeleton">
    {Array.from({ length: fields }, (_, i) => (
      <div key={i} style={{ marginBottom: 24 }}>
        <Skeleton.Input
          active
          size="small"
          style={{ width: 120, height: 16 }}
        />
        <div style={{ marginTop: 8 }}>
          <Skeleton.Input active block style={{ height: 32 }} />
        </div>
      </div>
    ))}
  </div>
);

export const MetaStripSkeleton: FC<{ items?: number }> = ({ items = 4 }) => (
  <div
    data-testid="meta-strip-skeleton"
    style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginBottom: 16 }}
  >
    {Array.from({ length: items }, (_, i) => (
      <Skeleton.Input key={i} active size="small" style={{ height: 16 }} />
    ))}
  </div>
);

export const BlockSkeleton: FC<{ height?: number }> = ({ height = 240 }) => {
  const rows = Math.max(3, Math.round((height - 48) / 40));
  return (
    <div data-testid="block-skeleton" style={{ height, paddingTop: 8 }}>
      <Skeleton
        active
        title={{ width: '45%' }}
        paragraph={{
          rows,
          width: Array.from({ length: rows }, (_, i) =>
            i % 2 === 0 ? '100%' : '75%',
          ),
        }}
      />
    </div>
  );
};
